// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { alphanumeric } from 'helpers/regex'
import { MUST_BE_ALPHANUMERIC } from 'errors'

const isAlphaNumeric = v => (
  v.length && !v.match(alphanumeric) && MUST_BE_ALPHANUMERIC
)

export default isAlphaNumeric
